const isNotEmpty = (value: string): boolean => {
    return value !== undefined && value !== null && value !== '';
}

export const buildRequestParameters = (loadOptions: any, key = '', value:any = null) => {
    let params = '?';
    [
        'skip',
        'take',
        'requireTotalCount',
        'requireGroupCount',
        'sort',
        'filter',
        'totalSummary',
        'group',
        'groupSummary',
        'export'
    ].forEach((i) => {
        if (key && value && key === i) {
            // Always include the custom filter override, merging with any existing loadOptions filter
            let options = (i in loadOptions) ? loadOptions[i] : null;
            if (options) {
                options = [options, 'and', value];
            } else {
                options = value;
            }
            let optionJSON = encodeURIComponent(JSON.stringify(options));
            params += `${i}=${optionJSON}&`;
        } else if (i in loadOptions) {
            if (isNotEmpty(loadOptions[i])) {
                if(i === "filter"){
                    if(Array.isArray(loadOptions[i]) && Array.isArray(loadOptions[i][0])){
                        loadOptions[i].forEach((e:any)=>{
                        if(e[0]==="reConfirm" && e[1] === "=" && e[2] === false){
                            e[2] = null;
                        }
                    })
                }else{
                    if(loadOptions[i][0]==="reConfirm" && loadOptions[i][1] === "=" && loadOptions[i][2] === false){
                        loadOptions[i][2] = null
                    }
                }
                }
                let optionJSON = encodeURIComponent(JSON.stringify(loadOptions[i]));
                params += `${i}=${optionJSON}&`;
            }
        }
    });

    params = params.slice(0, -1);
    return params;
}
